import downloadIcon from 'assets/icons/download.svg';
import { useToggle } from 'customHooks/useToggle';
import Button, { Size, TextOverflow } from 'lib/Button';
import { ExportAssetDataPanel } from '../ExportAssetDataPanel/ExportAssetDataPanel';

export const DownloadAssetDataButton = (): React.ReactElement | null => {
  const { isOpen, open, close } = useToggle(false);

  return (
    <>
      <Button
        label="Download asset data"
        size={Size.MEDIUM}
        svg={downloadIcon}
        svgClassnames="mr-[4px]"
        onClick={open}
        textOverflow={TextOverflow.VISIBLE}
        dataPendoId="/inventory-management/setup | Download asset data"
      />

      {isOpen && <ExportAssetDataPanel onClose={close} />}
    </>
  );
};
